export default __webpack_public_path__ + "static/media/Ring.6a26060e.svg";